import './instrument.js'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.jsx'
import { hasConsent, initGA } from './services/analytics'

// Re-initialise GA on page load if the user already gave consent
if (hasConsent()) initGA();

createRoot(document.getElementById('root'), {
  // React 19: capture uncaught and caught render errors via Sentry
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
)
